import {Alert, Snackbar} from "@mui/material";
import {useState} from "react";

export const useCopiarPortapapeles = () =>{
    const [open,setOpen] = useState(false)
    const [texto,setTexto] = useState('')

     const copiarPortapapeles = async (texto) => {

        try {
            await navigator.clipboard.writeText(texto);
            setTexto('Dirección copiada')
            setOpen(true)
        } catch (err) {
            setTexto('Tu navegador no permite esta accion')
            setOpen(true)
        }

    }

    const AvisoPortapapeles = () =>{

        return(
            <Snackbar
                open={open}
                onClose={() => setOpen(false)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                autoHideDuration={5000}
            >
                <Alert
                    severity={'secondary'}
                    variant="filled"
                >
                    {texto}
                </Alert>
            </Snackbar>
        )
    }

    return{
        AvisoPortapapeles,
        copiarPortapapeles
    }

}